import { ActionState } from './actions';
import { TriggerState } from './triggers';

export interface WorkflowState {
  workflowId: string;
  triggerState?: TriggerState;
  actionState?: ActionState;
}
